export default __webpack_public_path__ + "static/media/mypic.e36f353d.jpeg";